import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import Profile from '@/views/profile/Profile.vue';
import { profileExamResultsRoute } from './profieExamResults';
import { profileCalendarRoute } from './profileCalendar.route';
import { profileDetailsRoute } from './profileDetails.route';
import { profileEditRoute } from './profileEdit.route';
import { profileMedicalExaminationRoute } from './profileMedicalExamination.route';
import { profileRolesRoute } from './profileRoles.route';

export const profileRoute: RouteConfig = {
  path: ':profileId',
  component: Profile,
  children: [
    profileDetailsRoute('profile'),
    profileEditRoute('profileEdit'),
    profileRolesRoute,
    profileCalendarRoute('profileCalendar'),
    profileMedicalExaminationRoute('profileMedicalExamination'),
    profileExamResultsRoute('profileExamResult')
  ],
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'breadcrumbs.profiles.view',
      name: 'profile'
    }
  },
  props: {
    tabs: [
      { title: 'tabs.profile.details', route: { name: 'profile' }, permissions: ['USER.GET'] },
      { title: 'tabs.profile.edit', route: { name: 'profileEdit' }, permissions: ['USER.UPDATE'] },
      { title: 'tabs.profile.roles', route: { name: 'profileRoles' }, permissions: ['USER.ROLE_MANAGE'] },
      {
        title: 'tabs.profile.calendar',
        route: { name: 'profileCalendar', params: { view: 'week' } },
        permissions: ['USER.EVENTS']
      },
      {
        title: 'tabs.profile.medicalExamination',
        route: { name: 'profileMedicalExamination' },
        permissions: ['USER.MEDICAL_EXAMINATION']
      },
      {
        title: 'tabs.profile.examResult',
        route: { name: 'profileExamResult' },
        permissions: ['USER.EXAM_RESULT']
      }
    ]
  },

  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('profile/setId', tryParseInt(to.params.profileId));
    store
      .dispatch('profile/get')
      .then(profile => {
        profileRoute.meta.breadcrumb.title = profile.email;
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'messages.profile.getError' }));
  }
};
